var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.865 10.9502L20.419 11.8098C20.7374 11.9859 20.935 12.321 20.935 12.6848V21.5497C20.935 22.3032 20.1333 22.786 19.4673 22.4336L15.4123 20.288C15.109 20.1275 14.7445 20.1338 14.4468 20.3046L9.88943 22.9206C9.5776 23.0996 9.19368 23.0974 8.88391 22.9149L4.55731 20.3653C4.25225 20.1855 4.065 19.8578 4.065 19.5037V10.6355C4.065 9.86716 4.8954 9.38585 5.56207 9.76774L9.12797 11.8104C9.43586 11.9868 9.81415 11.9868 10.122 11.8105L11.755 10.8752",
    stroke: "#F1F2F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12L9.5 22",
    stroke: "#F1F2F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.515 10.0702H19.53L16.1389 14.5741C15.7388 15.1055 14.9412 15.1055 14.5411 14.5741L11.15 10.0702H11.165C10.29 9.08516 9.755 7.78516 9.755 6.36516C9.755 3.28516 12.255 0.785156 15.335 0.785156C18.415 0.785156 20.915 3.28516 20.915 6.36516C20.915 7.78516 20.385 9.08016 19.505 10.0702H19.515Z",
    stroke: "#F1F2F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.34 8.28945C16.6103 8.28945 17.64 7.25971 17.64 5.98945C17.64 4.7192 16.6103 3.68945 15.34 3.68945C14.0698 3.68945 13.04 4.7192 13.04 5.98945C13.04 7.25971 14.0698 8.28945 15.34 8.28945Z",
    stroke: "#F1F2F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.62c853784334971b3eeeecd839e2572e.svg";
export { ForwardRef as ReactComponent };